import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import * as XLSX from 'xlsx';
import { db } from '../firebase';
import { useCompanySession } from '../session';
import CompanyLayout from '../components/CompanyLayout';

function ImportData() {
    const { session, loading } = useCompanySession();
    const [file, setFile] = useState(null);
    const [importing, setImporting] = useState(false);
    const [importResult, setImportResult] = useState(null);

    const handleImport = async () => {
        if (!file) return alert('Select file asset');
        setImporting(true);
        try {
            const data = await file.arrayBuffer();
            const workbook = XLSX.read(data, { type: 'array' });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet);

            for (const row of rows) {
                await addDoc(collection(db, 'tenants', session.tenantId, 'customers'), {
                    fullName: row['Full Name'] || '',
                    nationalId: String(row['National ID'] || '').toUpperCase().trim(),
                    phone: String(row['Phone'] || '').trim(),
                    email: String(row['Email'] || '').toLowerCase().trim(),
                    medicalDefaultProfile: {
                        hasPreExistingConditions: String(row['Has Pre-Existing Conditions'] || 'NO').toUpperCase() === 'YES',
                        dependentsCount: parseInt(row['Dependents Count'] || '0', 10),
                        ageBracket: String(row['Age Bracket'] || 'ADULT').toUpperCase()
                    },
                    createdAt: new Date().toISOString(),
                    imported: true
                });
            }
            setImportResult({ success: true, imported: rows.length, errors: 0 });
        } catch (err) {
            setImportResult({ success: false, error: err.message });
        }
        setImporting(false);
    };

    if (loading || !session) return <div className="p-5">Loading...</div>;

    return (
        <CompanyLayout session={session}>
            <h2 className="text-xl font-bold mb-4">Batch Ledger Ingestion</h2>
            <div className="card border-0 shadow-sm p-4 bg-white">
                <input type="file" className="form-control mb-3" accept=".xlsx,.xls,.csv" onChange={(e) => setFile(e.target.files[0])} />
                <button className="btn btn-primary rounded-xl font-bold text-xs uppercase" onClick={handleImport} disabled={importing}>{importing ? 'Processing Ingestion...' : 'Execute Import'}</button>
            </div>
            {importResult && <div className="alert alert-info mt-3">Import process executed complete. Check log arrays.</div>}
        </CompanyLayout>
    );
}
export default ImportData;
